import script from "./FlightPortalMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./FlightPortalMobile.vue?vue&type=script&setup=true&lang=js"

import "./FlightPortalMobile.vue?vue&type=style&index=0&id=f5817686&lang=scss"

const __exports__ = script;

export default __exports__